module.exports = __webpack_public_path__ + "img/harry_potter_02_and_the_chamber_of_secrets.2b69f1d7.jpg";